import { Component, input, output } from '@angular/core';
import { PalantirIconComponent } from '../../../icon/icon.component';
import { PalantirTooltipModule } from '../../../tooltip/tooltip.module';

@Component({
  selector: 'fx-dynamic-tabular-table-header-cell',
  standalone: true,
  imports: [PalantirIconComponent, PalantirTooltipModule],
  templateUrl: './dynamic-tabular-table-header-cell.component.html',
})
export class FxDynamicTabularTableHeaderCellComponent {
  public readonly columnHeader = input.required<string>();

  public readonly readonly = input<boolean>(false);

  public readonly canRemove = input<boolean>(false);

  public readonly remove = output();
}
